import styled from 'styled-components';

const PageLoaderContainer = styled.div`
  height: 100vh;
`;

export default {
  PageLoaderContainer,
};
